import { useState } from "react";
import { bool, func, number } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { LOCKED_FEATURES } from "@utils";
import { useFeatureGuardian, useStores } from "@hooks";
import { WorkspaceInvite } from "@dialogs";
import { ActionButton, Button } from "@components";
import Grid from "@material-ui/core/Grid";
import { Add, AddOutlined } from "@material-ui/icons";
import classnames from "classnames";

export const SeatsCounterDetails = observer(({
  users,
  onInvite,
  isLoading,
  useActionButton,
}) => {
  const { t } = useTranslation();
  const { userStore } = useStores();
  
  const { checkAccess, FeatureAlert } = useFeatureGuardian(
    LOCKED_FEATURES.USER
  );
  
  const [ inviteModalVisible, openInviteModal ] = useState(false);
  
  const { premiumUsers } = userStore.subscriptionInfo;
  
  const handleInviteModalOpen = async () => {
    const allowed = await checkAccess();
    if (!allowed) return;
    openInviteModal(true);
  };
  
  return (
    <Grid item container justifyContent="flex-end" alignItems="center">
      {
        !isLoading && premiumUsers >= 0 &&
        <p
          className={classnames(
            "text-secondary font-bold w-max ellipsis",
            useActionButton ? "mr-4" : "mr-2"
          )}
        >
          {t("views.team.seats", {
            seats:
              premiumUsers - users < 0
                ? 0
                : premiumUsers - users,
          })}
        </p>
      }
      {
        useActionButton
          ? <ActionButton
            icon={<AddOutlined />}
            disabled={isLoading}
            onClick={handleInviteModalOpen}
          >
            {t("views.team.add")}
          </ActionButton>
          : <Button
            variant="outlined"
            size="small"
            icon={<Add />}
            disabled={isLoading} // || (premium_users >= 0 && premium_users-users.length <= 0)}
            onClick={handleInviteModalOpen}
          >
            {t("views.team.add")}
          </Button>
      }
      
      <FeatureAlert />
      <WorkspaceInvite
        onClickAway={() => openInviteModal(false)}
        isOpen={inviteModalVisible}
        onInvite={onInvite}
        useTechnicalInvites
      />
    </Grid>
  )
})

SeatsCounterDetails.propTypes = {
  users: number.isRequired,
  onInvite: func.isRequired,
  isLoading: bool,
  useActionButton: bool
}